import { FASTRadio as c, radioTemplate as d } from "@matrix42/fast-foundation";
import { html as a } from "@microsoft/fast-element";
import { radioGroupOptionStyles as o } from "./radio-group-option.styles.js";
const e = class e extends c {
  checkedChanged(s, t) {
    super.checkedChanged(s, t), t ? this.classList.add("checked") : this.classList.remove("checked");
  }
};
e.definition = {
  name: "radio-group-option",
  template: () => d({
    checkedIndicator: a`<i class="indicator"></i>`
  }),
  styles: () => o
};
let i = e;
export {
  i as RadioGroupOption
};
